import { render, staticRenderFns } from "./ancestorMemorial.vue?vue&type=template&id=c1b0e49c&scoped=true&"
import script from "./ancestorMemorial.vue?vue&type=script&lang=js&"
export * from "./ancestorMemorial.vue?vue&type=script&lang=js&"
import style0 from "./ancestorMemorial.vue?vue&type=style&index=0&id=c1b0e49c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b0e49c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b0e49c')) {
      api.createRecord('c1b0e49c', component.options)
    } else {
      api.reload('c1b0e49c', component.options)
    }
    module.hot.accept("./ancestorMemorial.vue?vue&type=template&id=c1b0e49c&scoped=true&", function () {
      api.rerender('c1b0e49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/appearance/ancestorMemorial.vue"
export default component.exports